import clsx from "clsx";
import Button from "@/components/ui/button";
import Dialog from "@/components/ui/dialog/Dialog";
import DialogCommonContent from "@/components/ui/dialog/DialogCommonContent";
import { DESIGN_RESET_DIALOG } from "@/const/dialogMessage";
import useDesignResetDialog from "./DesignResetDialog.hook";
import styles from "./DesignResetDialog.module.scss";

type Props = {
	disabled: boolean;
	onApplyClick: () => void;
};

/**
 * リセットボタンダイアログ コンポーネント
 * @returns {JSX.Element} リセットボタンダイアログ コンポーネント
 */
export default function DesignResetDialog(props: Props) {
	const { disabled, onApplyClick } = props;
	const { isDialogOpen, onDialogChange, onResetButtonClick } =
		useDesignResetDialog({
			onApplyClick,
		});
	const { message, applyMessage, warning } = DESIGN_RESET_DIALOG;

	return (
		<Dialog
			title="リセット"
			open={isDialogOpen}
			onOpenChange={onDialogChange}
			TriggerComponent={
				<Button
					className={clsx(
						styles.showModalBtn,
						disabled && styles.disabled,
					)}
					disabled={disabled}
				>
					リセット
				</Button>
			}
			ContentComponent={
				<DialogCommonContent
					message={message}
					applyMessage={applyMessage}
					warning={warning}
					onClick={onResetButtonClick}
				/>
			}
		></Dialog>
	);
}
